import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonServiceService } from '../services/common-service.service';
import { AuthService } from '../services/auth.service';
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  
  constructor(private _service: CommonServiceService,private authService:AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getAuthToken(request.url)
    if (request.url.includes('s3.ap-south-1.amazonaws.com')) {
      return next.handle(request);
    }
    if(request.url.indexOf('api.postalpincode.in/pincode') === -1) {
      request = request.clone({
        setHeaders: {
         'Authorization': `Bearer ${token}`
        }
     });
    }

    return next.handle(request);
  }
}
